<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>审核报废</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="org-tree-layout">
            <swb-popover-org-tree :showMgmt="true" :bizDepart="true" :showIncludeSubComs="true" :initIncludeSubComs="initIncludeSubComs" @notity-change="checkComCatChange($event)"></swb-popover-org-tree>
        </div>
        <swb-query-sort-area name="query-sort-area" ref="query_model_ctrl" class="mb10 mt10" :confKey="confKey" :queryOnLoad="queryOnLoad" :onConfigReady="onConfigReady" :configAuto="true" :queryHandler="queryHandler"></swb-query-sort-area>
        <div name="tabs-block">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="全部" name="auditAll"></el-tab-pane>
                <el-tab-pane name="auditInitial">
                    <span slot="label">审核中<!--<i class="num-marker">{{appliedCount}}</i>--></span>
                </el-tab-pane>
                <el-tab-pane label="审核已通过" name="auditPass"></el-tab-pane>
                <el-tab-pane name="auditFail">
                    <span slot="label">审核未通过<!--<i class="num-marker">{{auditFailCount}}</i>--></span>
                </el-tab-pane>
            </el-tabs>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName"
                          :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="tableHeight"
                          :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
import { Utils, $ } from '../../app.base'
import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
import { checkUserActionPerm } from '../index'
import { getDefaultPageSizes } from '../../app.conf'
import { openShopDeviceScrapVoucherAuditDlg } from './selectDlg'
import { openOaAuditRecDlg } from '../oaAudit/selectDlg'
import { getIncludeSubComsByMetaQueryConf } from '../conf/ComnConfStorer'
//
import userApi from '../../api/user'
import shopDevcApi from '../../api/shopDevc'
import assetVchrApi from '../../api/assetVchr'
import retailerApi from '../../api/retailer'
import oaAuditApi from '../../api/oaAudit'
//
import SwbShopDeviceScrapVoucherView from './ShopDeviceScrapVoucherView'
import SwbApplyDesc from '../bizUnion/ApplyDesc';
import SwbResultColConf from '../query/ResultColConf.vue';
import SwbResultTable from '../query/ResultTable.vue';
//
Vue.regist(SwbShopDeviceScrapVoucherView);
Vue.regist(SwbApplyDesc);
Vue.regist(SwbResultColConf);
Vue.regist(SwbResultTable);
export default {
    name: 'swb-shop-device-scrap-voucher-audit',
    path: '/shop/device/scrap/voucher/audit/list',
    avlActions: 'view_detail|audit|view_rec',
    avlScopes: 'retailer',
    desc: '资产报废列表',
    data: function () {
        return {
            confKey: 'swb-shop-device-scrap-audit-voucher',
            tableHeight: 300,
            queryOnLoad: true,
            //
            needPager: true, //是否需要分页（默认：true）
            multiSelect: false, //是否多选（默认：false）
            multiPageSelect: false, //是否要多页/跨页选择（默认：false）
            rowKeyPropName: 'id', //记录数据关键标识列名（多页/跨页选择必须，默认: id）
            rowNoShow: false, //是否显示行号（默认：true）
            rowNoFixed: false, //行号列是否固定（默认：false）

            btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
            //
            btnColTitle: '操作',//操作列标题（默认：'操作'）
            btnColWidth: 200,//操作列宽度（默认：100）
            //
            btnColFixed: true, //操作列是否固定
            //
            pageSize: getDefaultPageSizes().first(),
            pageNumber: 1,
            //排序、搜索
            queryKey: null,
            AuditPass: null,
            queryModel: {
                filterItems: {},
                sortItemList: [],
                sortItems: {},
            },
            activeName: 'auditAll',
            appliedCount: 0,
            auditFailCount: 0,
            //
            includeSubComs: false,
            initIncludeSubComs: false,
            initCheckStateValue: null,
            comLevel: null,
            selectComId: null,
            selectComName: null,
            scopeEntity: null,
            mgmtSmlAreaId: null,
            isAuditBpConfAvailable: false,
            scrapVoucher: {},
            ledgerStatePjRecvDone: getEnumInfoWith('ledgerState', 'name', 'PjRecvDone').value, // 接受完毕，对方单据已返回
            ledgerStateMap: getEnumMap('ledgerState', 'value2text'),
            devcVoucherTypeMap: getEnumMap('devcVoucherType', 'value2text'),
            innerNo: null
        }
    },
    created: function () {
        //
        let self = this;
        let innerNo = this.$route.query.innerNo || null;
        if(!Utils.isNoB(innerNo)) {
            this.queryModel.filterItems.innerNo = innerNo;
            this.innerNo = innerNo;
        }
        //
        getIncludeSubComsByMetaQueryConf(this.confKey, function (includeSubComs) {
            self.includeSubComs = includeSubComs;
            self.initIncludeSubComs = includeSubComs;
        });
    },
    mounted() {
        let self = this;
        //注册domSizeWatcher
        let thisEl = $(this.$el);
        $(this.$el).addClass('overflow-hidden');
        //
        let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
        domSizeWatcher.setBaseEl(thisEl);
        domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
            //根据新主元素的内容大小，调整表格高度
            self.tableHeight = height;

        });
        //domSizeWatcher.setHrEls();
        domSizeWatcher.setVtEls(thisEl.find('.breadcrumb-layout, .org-tree-layout, [name="query-sort-area"],[name="tabs-block"]'));
        domSizeWatcher.start(500);
        //
        this.initResultTable();
        //
        this.isMerchtAuditBpConfAvailable();
        this.getCurrUserInfo();
    },
    destroyed() {
        //释放domSizeWatcher
        let domSizeWatcher = this.domSizeWatcher;
        if(domSizeWatcher != null) {
            domSizeWatcher.clear();
            this.domSizeWatcher = null;
        }
    },
    methods: {
        getCurrUserInfo() {
            let self = this;
            userApi.getUserInfoByContext({}, function (result) {
                if(result.type == 'info') {
                    self.scopeEntity = result.data.scopeEntity;
                    //
                    if(self.includeSubComs) {
                        self.selectComId = self.scopeEntity.comId;
                        self.selectComName = self.scopeEntity.comName;
                        self.bizUnitId = self.scopeEntity.bizUnitId;
                        self.bizUnitName = self.scopeEntity.bizUnitName;
                        self.comLevel = self.scopeEntity.comLevel;
                    }
                }
            });
        },
        onConfigReady: function () {
            // 生凭状态
            let dataList = [{'value': null, 'label': '- 全部 -'}];
            let ledgerStateList = getEnumList('ledgerState');
            ledgerStateList.forEach(function (item) {
                let ledgerState = {};
                ledgerState.value = item.value;
                ledgerState.label = item.text;
                dataList.push(ledgerState);
            });
            this.updateQueryModelField('ledgerState', dataList);
            //
            let query_model_ctrl = this.$refs['query_model_ctrl'];
            let innerNo = this.innerNo;
            if(!Utils.isNoB(innerNo)) {
                let data = {value: innerNo};
                let fieldInfo = {};
                fieldInfo['innerNo'] = data;
                query_model_ctrl.updateFields(fieldInfo);
            }
        },
        updateQueryModelField: function (itemCode, dataList = []) {
            if(itemCode != null) {
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let data = {dataList: dataList};
                let fieldInfo = {};
                fieldInfo[itemCode] = data;
                query_model_ctrl.updateFields(fieldInfo);
            }
        },
        isMerchtAuditBpConfAvailable: function () {
            let self = this;
            oaAuditApi.isMerchtAuditBpConfAvailable({bizTypeCode: 'retailer.assets.scrap'}, function (result) {
                if(result.type == 'info') {
                    self.isAuditBpConfAvailable = result.data;
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        initResultTable() {
            let self = this;
            let query_model_ctrl = this.$refs['query_model_ctrl'];
            let resultTable = this.$refs['result_table'];
            //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
            resultTable.setQrySortRef(query_model_ctrl);
            //
            resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                // 生凭状态
                'ledgerState': function (row, colName, colValue, rowIndex) {
                    return '<span>' + self.ledgerStateMap[row.ledgerState] + '</span>';
                },
                'auditState': function (row, colName, colValue, rowIndex, colConf) {
                    if(row.applyState == 0) {
                        return '<span class="font-gray1">未申请</span>';
                    } else if(row.applyState == 1) {
                        return '<span class="font-gold">已申请</span>';
                    } else if(row.applyState == 2) {
                        if(row.auditState === 1) {
                            return '<span class="font-green">审核已通过</span>';
                        } else if(row.auditState === -1) {
                            return '<span class="font-red">审核未通过</span>';
                        }
                    }
                },
                'srcVoucherTypeTxt': function (row, colName, colValue, rowIndex) {
                    return '<span>' + self.devcVoucherTypeMap[row.srcVoucherType] + '</span>';
                },
                'actions': function (row, colName, colValue, rowIndex) {
                    let domHtml = '';
                    if(self.checkActionPerm('audit', row.auditorPostId, row.comId) && !row.invalid && (row.auditorStaffId == null || self.scopeEntity.staffId == row.auditorStaffId) && !row.outerAuditFlag && !Utils.isTrue(self.isAuditBpConfAvailable) && row.applyState == 1 && row.auditState != 1) { // && row.ledgerState == self.ledgerStatePjRecvDone
                        domHtml = domHtml + '<a name="audit" class="swb-btn swb-btn-link">审核</a>';
                    }
                    if(self.checkActionPerm('view_detail', null, row.comId)) {
                        domHtml = domHtml + '<a name="view_detail" class="swb-btn swb-btn-link">查看详情</a>';
                    }
                    if(self.checkActionPerm('view_rec', null, row.comId)) {
                        domHtml = domHtml + '<a name="view_rec" class="swb-btn swb-btn-link">操作记录</a>';
                    }
                    if(row.outerAuditFlag && row.applyState != 0 && self.checkActionPerm('audit_rec', null, row.comId)) {
                        domHtml = domHtml + '<a name="audit_rec" class="swb-btn swb-btn-link">单据审批记录</a>';
                    }
                    if(self.checkActionPerm('fiscalSsp', null, row.comId) && row.fiscalSspFlag) {
                        domHtml = domHtml + '<a name="fiscalSsp" class="swb-btn swb-btn-link">重新执行</a>';
                    }
                    return domHtml;
                }
            }, /* 单元格按钮点击处理函数 */{
                //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                'actions': function (row, colName, colValue, rowIndex, btnName) {
                    if(!Utils.repeatChecker.isValidFor(btnName, 1000)) {
                        return;
                    }
                    if(btnName == 'audit') {
                        self.auditScrapVoucher(row);
                    } else if(btnName == 'view_detail') {
                        self.viewScrapVoucher(row.id);
                    } else if(btnName == 'view_rec') {
                        self.showActRec(row.no);
                    } else if(btnName == 'audit_rec') {
                        self.auditRscDlg(row.no, row.innerNo, row.auditSeqNo);
                    } else if(btnName == 'fiscalSsp') {
                        self.fiscalSsp(row.id);
                    }
                }
            });
        },
        auditRscDlg: function (no, innerNo, auditSeqNo) {
            let bizVoucherNo = no;
            if(!Utils.isNoB(innerNo)) {
                bizVoucherNo = innerNo;
            }
            openOaAuditRecDlg('retailer.assets.scrap', auditSeqNo, bizVoucherNo);
        },
        renderTable(rows, pagination) {
            //
            let resultTable = this.$refs.result_table;
            //清除数据（如果已经渲染的数据与新的列不是一回事儿）
            //resultTable.clear();
            //同步使用新的自定义列信息
            //resultTable.initMeta(confColList);
            //设置新数据
            let tableData = {
                rows: rows,
                pagination: pagination
            };

            resultTable.render(tableData);
        },
        // 单元格点击事件
        rowDblClickHandler: function (row) {
            if(!this.multiSelect) {
                console.log('----- 双击数据行 ----');
                console.log(row);
            }
        },
        checkActionPerm: function (action, targetPostId, dataOwnerComId) {
            return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId, dataOwnerComId);
        },
        queryHandler(queryModel) {
            //1、接收查询条件
            this.queryModel = queryModel;
            this.pageNumber = 1;
            //缓存查询条件
            this.getShopDeviceScrapVoucherList();
        },
        pageNoChangeHandler: function (pageNumber, pageSize) {
            console.log('分页 => 第【' + pageNumber + '】页，大小：' + pageSize);
            //
            this.pageSize = pageSize;
            this.pageNumber = pageNumber;
            //
            this.getShopDeviceScrapVoucherList();
        },

        handleSizeChange: function (val) {
            let curStartIndex = (this.pageNumber - 1) * this.pageSize;
            this.pageSize = val;
            let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
            this.handlePageChange(newPageNumber);
        },
        handlePageChange: function (val) {
            this.pageNumber = val;
            this.getShopDeviceScrapVoucherList();
        },
        handleClick() {
            this.handlePageChange(1);
        },
        checkComCatChange: function (eventData) {
            this.mgmtSmlAreaId = null;
            if(Utils.isTrue(eventData.mgmtFlag)) {
                let scopeEntity = this.scopeEntity;
                this.comLevel = scopeEntity.comLevel;
                this.selectComId = scopeEntity.comId;
                this.selectComName = scopeEntity.comName;
                this.includeSubComs = true;
                this.mgmtSmlAreaId = eventData.id;
            } else {
                this.selectComId = eventData.id;
                this.selectComName = eventData.name;
                this.comLevel = eventData.level;
                this.includeSubComs = eventData.includeSubComs;
            }
            this.getShopDeviceScrapVoucherList();
        },
        getShopDeviceScrapVoucherList: function () {
            let self = this;
            let postData = {};
            postData.pagination = {
                pageSize: self.pageSize,
                pageNumber: self.pageNumber,
            };
            //
            let queryModel = self.queryModel;
            let filterItems = Utils.merge({}, queryModel.filterItems);
            let sortItemList = Utils.merge([], queryModel.sortItemList);
            let sortItems = Utils.merge({}, queryModel.sortItems);
            //
            filterItems.tabCheckFlag = self.activeName;
            filterItems.auditState = filterItems.state;
            //
            filterItems.includeSubComs = this.includeSubComs;
            filterItems.retailerComId = this.selectComId || null;
            filterItems.comLevel = this.comLevel;
            filterItems.mgmtSmlAreaId = this.mgmtSmlAreaId;
            filterItems.bizType = 'scrap';
            filterItems.pcFlag = true;
            //
            postData.filterItems = filterItems;
            postData.sortItemList = sortItemList;
            postData.sortItems = sortItems;
            let theLoad = MsgBox.loading();
            assetVchrApi.getShopDeviceScrapVoucherList(postData, function (result) {
                theLoad.hide();
                if(result.type === 'info') {
                    let pagination = result.data.pagination;
                    self.totalCount = pagination.totalCount;
                    self.pageNumber = pagination.pageNumber;
                    self.renderTable(result.data.rows, pagination);
                    //
                    // self.getApplyStateAppliedTodoCount();
                    // self.getAuditStateAuditFailTodoCount();
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        getApplyStateAppliedTodoCount: function () {
            let self = this;
            let postData = {
                comId: this.selectComId,
                comLevel: this.comLevel,
                includeSubComs: this.includeSubComs,
            }
            assetVchrApi.getShopDeviceScrapVoucherApplyStateAppliedTodoCount(postData, function (result) {
                if(result.type == 'info') {
                    self.appliedCount = result.data;
                }
            })
        },
        getAuditStateAuditFailTodoCount: function () {
            let self = this;
            let postData = {
                applyFlag: true,
                comId: this.selectComId,
                comLevel: this.comLevel,
                includeSubComs: this.includeSubComs,
            }
            assetVchrApi.getShopDeviceScrapVoucherAuditStateAuditFailTodoCount(postData, function (result) {
                if(result.type == 'info') {
                    self.auditFailCount = result.data;
                }
            })
        },
        // 审核报废单
        auditScrapVoucher: function (row) {
            let self = this;
            openShopDeviceScrapVoucherAuditDlg(function (result) {
                console.log(result);
                let postData = {
                    id: row.id,
                    auditState: result.auditState,
                    auditDesc: result.desc,
                    devcClearFlag: result.devcClearFlag,
                    fiscalClearFlag: result.fiscalClearFlag,
                };
                let theLoad = MsgBox.loading();
                self.scrapVoucher = Utils.merge({}, result.scrapVoucher);
                if(!Utils.isNoB(self.scrapVoucher) && !Utils.isNoB(self.scrapVoucher.id)) {
                    self.scrapVoucher.itemList = self.scrapVoucher.deviceItems.concat(self.scrapVoucher.durableItems);
                    self.scrapVoucherSubmit(self.scrapVoucher, function () {
                        assetVchrApi.aduitShopDeviceScrapVoucher(postData, function (result) {
                            theLoad.hide();
                            if(result.type == 'info') {
                                MsgBox.success('操作成功！');
                                self.getShopDeviceScrapVoucherList();
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    });
                } else {
                    assetVchrApi.aduitShopDeviceScrapVoucher(postData, function (result) {
                        theLoad.hide();
                        if(result.type == 'info') {
                            MsgBox.success('操作成功！');
                            self.getShopDeviceScrapVoucherList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }
            }, null, row.id);
        },
        scrapVoucherSubmit: function (scrapVoucher, callback) {
            assetVchrApi.saveShopDeviceScrapVoucherItem(scrapVoucher, function (result) {
                if(result.type == 'info') {
                } else {
                    MsgBox.warning(result.message);
                }
                callback();
            });
        },
        // 报废单详情
        viewScrapVoucher: function (id) {
            Vue.$showDialog({
                title: '资产报废单--详情',
                width: -200,
                height: -100,
                okVisible: false,
                showCloseBtn: true,
                cancelText: '关闭',
                template: '<div>' +
                    '<swb-shop-scrap-voucher-view :id="id"></swb-shop-scrap-voucher-view>' +
                    '</div>',
                data: {
                    id: id,
                }
            });
        },

        // 报废单操作记录
        showActRec(no) {
            Vue.$showDialog({
                title: '报废单操作记录 - 查看',
                width: 1200,
                height: 800,
                okVisible: false,
                showCloseBtn: true,
                okClicked: false,
                cancelText: '关闭',
                template: '<div>' +
                    '<swb-shop-device-act-rec-list :showComFlag="false" :srcVoucherNo="srcVoucherNo" :srcVoucherType="srcVoucherType" ref="swb_shop_device_act_rec_list"></swb-shop-device-act-rec-list>' +
                    '</div>',
                data: {
                    srcVoucherNo: no,
                    srcVoucherType: getEnumInfoWith('devcVoucherType', 'name', 'Scrap').value
                }
            });
        },
        // 重新执行
        fiscalSsp: function (id) {
            let self = this;
            self.$confirm('确定要执行吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                let params = {
                    voucherId: id
                };
                let msgBoxDlg = MsgBox.loading();
                assetVchrApi.saveScrapAssetAuditPassAgain(params, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        MsgBox.success('操作成功！');
                        self.getShopDeviceScrapVoucherList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }).catch(function () {
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/scrapVoucher/ShopDeviceScrapVoucherAuditList.vue